// 导出名字汇总
export const FILE_NAME_CONFIG = {
    1: '商品导出',
    2: '账单明细导出',
    5: '优惠券明细导出',
    6: '优惠券分销商统计数据导出',
    7: '活动页商品数据导出',
    8: '爆单挑战详情数据导出',
    9: '奖励金额明细导出',
    12: '节庆活动板块二数据导出',
    13: '节庆活动板块三数据导出',
    14: '订单导出',
    15: '物流对账信息导出',
    16: '招商统计信息导出',
    17: '商品补贴明细导出',
    19: '用户运营信息导出',
    20: '分销商活动管理数据导出',
    24: '分销商提现记录导出',
    25: '供应商提现记录导出',
    26: '纠纷订单信息导出',
    27: '订单对账信息导出',
    28: '无物流商品导出',
    29: '运营助理信息导出',
    31: '分销商充值记录导出',
    32: '调价商品列表导出',
    33: '已调价商品列表导出',
    34: '供应商未结算金额记录信息导出',
    35: '供应商订单放款记录信息导出',
    36: '供应商订单退款记录信息导出',
    40: '供应商信息导出',
    41: '分销商信息导出',
    42: '品牌列表信息导出',
    43: '国际小包订单导出',
    44: '海外商品导出',
    45: '分销商资金明细信息导出',
    49: '供应商资金明细信息导出',
    50: '转出明细导出',
    51: '财务实收款明细',
    55: '经营许可证',
    57: '业务员提现记录导出',
    60: '加盟数据记录导出',
    61: '代理运营中心的加盟数据记录导出',
    62: '加盟费明细导出',
    80: '供应商用户反馈记录导出',
    81: '分销商用户反馈记录导出',
};

// 获取当前时间
export function getCurrentDateTime() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需+1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
};
